module.exports = __webpack_public_path__ + "img/P150T_weapon_35.f40a022a.png";